import '@d3fc/d3fc-element';
import { seriesSvgLine } from '@d3fc/d3fc-series';
import { deriveTime } from 'utils/components/TimeSeriesChart/TimeSeriesChartData';

/* eslint-disable @typescript-eslint/no-explicit-any */

export function createArriveCloseLine(
    lineType: 'Arrival' | 'Close' | 'Open',
    price?: number
) {
    const cssClass = lineType.toLowerCase() + 'Line';

    return seriesSvgLine()
        .crossValue(deriveTime)
        .mainValue(price)
        .decorate((s: any) => {
            s.classed(cssClass, true);
        });
}
